<template>
  <div class="custom-main custom-theme" style="margin: 0px;">
    <a-layout class="ant-layout-body">
      <gpws-header/>
      <a-layout-content>
        <a-row>
          <a-col :xxl="2" :xl="2" :lg="2" :md="0" :sm="0" :xs="0">&nbsp;</a-col>
          <a-col :xxl="20" :xl="20" :lg="20" :md="24" :sm="24" :xs="24">
            <a-card>
              <a-row>
                <a-col span="24" style="padding-left:24px;padding-bottom: 20px;border-bottom: 1px solid #e8e8e8; box-sizing: border-box">
                  <a-button-group shape="round">
                    <a-button size="default" :class="(init.business =='A'?'gpws-business-left-active':'gpws-business-left-btn')" @click="businessChecked('A')">病症论治</a-button>
                    <a-button size="default" :class="(init.business =='B'?'gpws-business-active':'gpws-business-btn')" @click="businessChecked('B')">症症论治</a-button>
                    <a-button size="default" :class="(init.business =='C'?'gpws-business-right-active':'gpws-business-right-btn')" @click="businessChecked('C')">方剂大全</a-button>
                  </a-button-group>
                </a-col>
              </a-row>
              <a-card :bordered="false" v-if="init.business == 'A'" style="margin-left: 6px;" :body-style="{'padding':'0px','padding-top':'10px'}">
                <disease-treatment @clickit="visitPrescription"></disease-treatment>
              </a-card>
              <a-card :bordered="false" v-if="init.business == 'B'" style="margin-left: 6px;" :body-style="{'padding':'0px','padding-top':'10px'}">
                <symptom-treatment @clickit="visitPrescription"></symptom-treatment>
              </a-card>
              <a-card :bordered="false" v-if="init.business == 'C'" style="margin-left: 6px;" :body-style="{'padding':'0px','padding-top':'10px'}">
                <encyclopedia @clickit="visitEncyclopedia"></encyclopedia>
              </a-card>
            </a-card>
          </a-col>
          <a-col :xxl="2" :xl="2" :lg="2" :md="0" :sm="0" :xs="0">&nbsp;</a-col>
        </a-row>
      </a-layout-content>
      <a-layout-footer style="padding: 0px!important;">
        <gpws-footer/>
      </a-layout-footer>
    </a-layout>
  </div>
</template>

<script>
import GpwsHeader from '@/components/base/Header.vue';
import GpwsFooter from '@/components/base/Footer.vue';
import DiseaseTreatment from '@/components/prescription/DiseaseTreatment.vue';
import SymptomTreatment from '@/components/prescription/SymptomTreatment.vue';
import Encyclopedia from '@/components/prescription/Encyclopedia.vue';
export default {
  name: "Prescription",
  components: {
    GpwsHeader,
    GpwsFooter,
    DiseaseTreatment,
    SymptomTreatment,
    Encyclopedia
  },
  data(){
    return {
      current:{},
      init:{
        business:'A'
      }
    }
  },
  mounted() {
    this.$store.commit('updateTopMenu', '202');
    this.current = JSON.parse(localStorage.getItem("curruser"));
  },
  methods:{
    visitPrescription:function (pres) {
      this.$router.push({ path : '/outpatient', query:{id:pres.id, symptoms:pres.symptoms, type:'p'} });
    },
    visitEncyclopedia:function (id) {
      this.$router.push({ path : '/outpatient', query:{id:id, type:'e'} });
    },
    businessChecked:function (business) {
      this.init.business = business;
    }
  }
}
</script>

<style scoped>
.gpws-business-left-active {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-left-radius: 18px!important;
  border-bottom-left-radius: 18px!important;
  color: white;
}

.gpws-business-right-active {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  border-top-right-radius: 18px!important;
  border-bottom-right-radius: 18px!important;
  color: white;
}
.gpws-business-left-btn {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-left-radius: 18px!important;
  border-bottom-left-radius: 18px!important;
}
.gpws-business-right-btn {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  border-top-right-radius: 18px!important;
  border-bottom-right-radius: 18px!important;
}
.gpws-business-active {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
  background: #2690C0;
  color: white;
}
.gpws-business-btn {
  width: 150px;
  height: 36px;
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 500;
}
</style>
